const TABLE_B = [
  { start: 0,    end: 359,  vals: [9,9,9,9,9,9,9] },
  { start: 400,  end: 459,  vals: [10,10,10,10,9,9,9] },
  { start: 500,  end: 559,  vals: [12,12,12,12,11.5,11,10.5] },
  { start: 600,  end: 659,  vals: [13,13,12,12,11.5,11,10.5] },
  { start: 700,  end: 1159, vals: [14,14,13,13,12.5,12,11.5] },
  { start: 1200, end: 1259, vals: [13,13,13,13,12.5,12,11.5] },
  { start: 1300, end: 1659, vals: [12,12,12,12,11.5,11,10.5] },
  { start: 1700, end: 2159, vals: [12,12,11,11,10,9,9] },
  { start: 2200, end: 2259, vals: [11,11,10,10,9,9,9] },
  { start: 2300, end: 2359, vals: [10,10,10,9,9,9,9] },
];

// TABLE A — max flight time hours
// Same pre-shifted UTC Date convention as getTableB — use getUTCHours().
export function getTableA(reportTime, pilots) {
  const h = reportTime.getUTCHours();
  if (h >= 5 && h < 20) {
    return pilots === 2 ? 9 : 13;
  } else {
    return pilots === 2 ? 8 : 13;
  }
}

// TABLE B — max FDP hours by report time and number of legs
// Falls back to 9 hrs for times not covered by any row (e.g. 0001-0359)
//
// IMPORTANT: date is a UTC Date pre-shifted to represent airport local time
// (localDate = utcDate + offsetMs), so we read getUTCHours/getUTCMinutes,
// NOT getHours() — otherwise the browser's own timezone is applied twice.
export function getTableB(date, legs) {
  const t = date.getUTCHours() * 100 + date.getUTCMinutes();
  const row = TABLE_B.find(r => t >= r.start && t <= r.end);
  if (!row) return 9;
  return row.vals[Math.min(legs, 7) - 1];
}